
import { createRoot } from 'react-dom/client'
import './index.scss'
import { RouterProvider } from 'react-router-dom'
import { routerProvider } from './providers/routerProvider'
import "leaflet/dist/leaflet.css";




createRoot(document.getElementById('root')!).render(

    <RouterProvider router={routerProvider} />,
)
